export const EVENTCARD_WRAPPER_CLASSES =
    'eds-g-cell eds-g-cell-1-1 eds-g-cell-mn-1-3 eds-g-cell--has-overflow event-card__container eds-l-pad-all-2';

export const FOLLOW_SIGNAL_EXPERIMENT = 'X6QS5eNNQv-yvej7Qyeldg';
